import { render } from "./MainHirings.vue?vue&type=template&id=203e39d6&scoped=true"
import script from "./MainHirings.vue?vue&type=script&lang=js"
export * from "./MainHirings.vue?vue&type=script&lang=js"

import "./MainHirings.vue?vue&type=style&index=0&id=203e39d6&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203e39d6"]])

export default __exports__